export default __webpack_public_path__ + "static/MINCLUSIONJARSSHOPPERTOTE2_600x600-9d137c7ef7b8dd69c51939b7c1e8a80e.png";